/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_BANK_ACCOUNTS',
  'DELETE_BANK_ACCOUNT',
  'CREATE_BANK_ACCOUNT',
  'UPDATE_PRIMARY_BANK_ACCOUNT',
]);



// WEBPACK FOOTER //
// ./src/payments/constants/ExternalAccountResourceConstants.js